import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import React, { useContext, useState, useCallback, useEffect } from "react";

import Filter from "../components/home/Filter";
import FilterResult from "../components/home/FilterResult";
import StagesPieChart from "../components/home/StagesPieChart";
import StatusCards from "../components/home/StatusCards";

import { Box, LinearProgress, Alert, Skeleton } from "@mui/material";
import { FilterContext } from "../contexts/FilterContext";
import { useHomeBaseData } from "../hooks/api/homeApiHooks";

import AppBarMenu from "../components/AppBarMenu";
import { ApiDataContext } from "../contexts/ApiDataContext";

export default function HomePage() {
  const [selectedProgress, setSelectedProgress] = useState();
  const [selectedStages, setSelectedStages] = useState([]);
  const [selectedPDCs, setSelectedPDCs] = useState([]);
  const [selectedIntegrators, setSelectedIntegrators] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);

  const { homeBaseDataLoading, homeBaseData } = useHomeBaseData();

  const { apiData } = useContext(ApiDataContext);

  // Restaurar ou definir defaults na inicialização
  useEffect(() => {
    const savedProgressName = sessionStorage.getItem("selectedProgressName");
    const savedProgressValue = sessionStorage.getItem("selectedProgressValue");
    
    if (savedProgressName && savedProgressValue) {
      setSelectedProgress({
        name: savedProgressName,
        value: parseInt(savedProgressValue),
      });
    } else {
      // DEFAULT: Atrasado (progress=1)
      setSelectedProgress({
        name: "Atrasado",
        value: 1,
      });
      sessionStorage.setItem("selectedProgressName", "Atrasado");
      sessionStorage.setItem("selectedProgressValue", "1");
    }
  }, []);

  // Set default de TODAS as etapas quando apiData carrega
  useEffect(() => {
    if (apiData.stages && apiData.stages.length > 0) {
      const savedStages = sessionStorage.getItem("selectedStages");
      
      if (!savedStages) {
        // DEFAULT: Todas as etapas
        setSelectedStages(apiData.stages);
        sessionStorage.setItem("selectedStages", JSON.stringify(apiData.stages));
      }
    }
  }, [apiData.stages]);

  const handleSelectProgress = useCallback((value, name) => {
    setSelectedProgress({
      name: name,
      value: value,
    });

    sessionStorage.setItem("selectedProgressName", name);
    sessionStorage.setItem("selectedProgressValue", value.toString());
  }, []);

  // Check if at least one filter is selected
  const hasAtLeastOneFilter = 
    selectedStages.length > 0 || 
    selectedPDCs.length > 0 || 
    selectedIntegrators.length > 0 || 
    selectedStates.length > 0;

  const canShowResults = selectedProgress && hasAtLeastOneFilter;

  return (
    <FilterContext.Provider
      value={[
        selectedProgress,
        setSelectedProgress,
        selectedStages,
        setSelectedStages,
        selectedPDCs,
        setSelectedPDCs,
        selectedIntegrators,
        setSelectedIntegrators,
        selectedStates,
        setSelectedStates,
      ]}
    >
      {homeBaseDataLoading || apiData === undefined ? (
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      ) : (
        <AppBarMenu>
          <Box
            sx={{
              backgroundColor: "#F7F8FA",
              minHeight: "100vh",
              py: 3,
            }}
          >
            <Container maxWidth="xl">
              {/* Grid Superior: Controles (Esquerda) + Gráfico (Direita) */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", lg: "2fr 1fr" },
                  gap: 3,
                  mb: 3,
                  alignItems: "start",
                }}
              >
                {/* Coluna Esquerda: Status Cards + Filtros */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  {/* Status Cards */}
                  <StatusCards
                    progressData={homeBaseData}
                    selectedProgress={selectedProgress}
                    onSelectProgress={handleSelectProgress}
                  />

                  {/* Filtros */}
                  <Filter />
                </Box>

                {/* Coluna Direita: Gráfico */}
                <Box sx={{ height: "100%" }}>
                  <StagesPieChart progressData={homeBaseData} />
                </Box>
              </Box>

              {/* Alert de Validação */}
              {selectedProgress && !hasAtLeastOneFilter && (
                <Box sx={{ mb: 3 }}>
                  <Alert severity="info" sx={{ borderRadius: 2 }}>
                    Selecione pelo menos um filtro (Etapa, Concessionária, Integrador ou Estado) para visualizar os projetos.
                  </Alert>
                </Box>
              )}

              {/* Área Inferior: Lista de Projetos (100% largura) */}
              {canShowResults && (
                <Box>
                  <FilterResult />
                </Box>
              )}
            </Container>
          </Box>
        </AppBarMenu>
      )}
    </FilterContext.Provider>
  );
}
